import { render, staticRenderFns } from "./driver_board.vue?vue&type=template&id=1130ca1c&scoped=true&"
import script from "./driver_board.vue?vue&type=script&lang=js&"
export * from "./driver_board.vue?vue&type=script&lang=js&"
import style0 from "./driver_board.vue?vue&type=style&index=0&id=1130ca1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130ca1c",
  null
  
)

export default component.exports